import { FC, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import InputMask from "react-input-mask";
import "./reset.css";
import api from "../../../services/api";
import Swal from "sweetalert2";
import { usePluginspace } from "../../../hooks/usePluginspace";
import { useConfig } from "../Auth";

type props = {
  close: () => void;
};

const ForgotPassword: FC<props> = ({ close }) => {
  const { getToken } = usePluginspace();
  const navigate = useNavigate();
  const params = useParams();

  const [loading, setLoading] = useState(false);
  const { config } = useConfig();

  const [maskCpfjCnpj, setmaskCpfjCnpj] = useState("999.999.999-99");
  const [cpfCustomer, setCpfCustomer] = useState("");

  async function resetPassword() {
    if (!cpfCustomer.trim() || cpfCustomer.includes("_")) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Preencha um CPF válido antes de continuar.",
      });
      return;
    }

    setLoading(true);
    localStorage.setItem("cpfReset", cpfCustomer);

    await api
      .post(
        `/api/customer/reset_password_code`,
        {
          cpf: cpfCustomer,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        },
      )
      .then(async (response) => {
        if (response.data.success) {
          navigate(`/${params.pluginspace_id}/reset_password`);
        } else {
          setLoading(false);
          // Caso o backend retorne HTTP 200/201 mas com success: false
          if (response.data.message === "plugin_email_inativo") {
            Swal.fire({
              icon: "info",
              title: "Serviço Indisponível",
              text: "O envio de e-mails não está habilitado no momento. Por favor, entre em contato diretamente com a loja para redefinir sua senha.",
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Atenção!",
              text: response.data.message || "Usuário não encontrado.",
            });
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);

        // NOVA VALIDAÇÃO AQUI: Interceptando o erro dentro do catch (HTTP 400+)
        if (
          err.response &&
          err.response.data &&
          err.response.data.message === "plugin_email_inativo"
        ) {
          Swal.fire({
            icon: "info",
            title: "Serviço Indisponível",
            text: "Por favor, entre em contato diretamente com a loja para redefinir sua senha.",
          });
        } else {
          // Comportamento genérico de erro
          Swal.fire({
            icon: "error",
            title: "Atenção!",
            text:
              err.response?.data?.message ||
              "Erro ao tentar se comunicar com o servidor.",
          });
        }
      });
  }

  const primaryColor = config?.webappcolor?.webappbutton
    ? config?.webappcolor?.webappbutton
    : "#078BD8";

  return (
    <div className="resetPasswordContent">
      <div className="close-modal">
        <span onClick={() => close()}>✕</span>
      </div>

      <div className="reset-text-container">
        <h3 style={{ color: primaryColor }}>Esqueci a senha</h3>
        <span>
          Insira o seu CPF. Você vai receber um link via email para gerar uma
          nova senha.
        </span>
      </div>

      <div className="reset-inputs">
        <div className="reset-input-group">
          <label>CPF:</label>
          <InputMask
            className="reset-input-field"
            mask={maskCpfjCnpj}
            placeholder="123.456.789-00"
            type="text"
            value={cpfCustomer}
            onChange={(event) => setCpfCustomer(event.target.value)}
          />
        </div>

        <button
          className="btn-login"
          style={{ background: primaryColor }}
          onClick={() => resetPassword()}
          disabled={loading}
        >
          {loading ? "Enviando..." : "Enviar"}
        </button>
      </div>
    </div>
  );
};

export { ForgotPassword };
